// extracted by mini-css-extract-plugin
export default {"Logo":"styles_Logo__lpiLT","header":"styles_header__0ZgsG","saveButtonsContainer":"styles_saveButtonsContainer__gmQUC","images":"styles_images__Fb3q5"};